import React from 'react'
import {Icon} from '@chakra-ui/react'

const ManualsIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path d="M11 8H6V10H11V8Z" fill="currentColor" />
            <path d="M16 16H6V18H16V16Z" fill="currentColor" />
            <path
                d="M16.41 0H2V24H22V5.59L16.41 0ZM16 2.41L19.59 6H16V2.41ZM20 22H4V2H14V8H20V22Z"
                fill="currentColor"
            />
            <path d="M18 12H6V14H18V12Z" fill="currentColor" />
        </Icon>
    )
}

export default ManualsIcon
